module.exports = __webpack_public_path__ + "img/finance.81257c4c.png";